import { useEffect, useState } from 'react';

export const useResourceState = (ips, hostnames) => {
    const [resourceState, setResourceState] = useState({
        selectedIps: [],
        selectedHostnames: []
    });

    const addResource = (type, resource) => {
        if (Array.isArray(resource)) {
            setResourceState((prevState) => ({
                ...prevState,
                [type]: [...prevState[type], ...resource]
            }));
            return;
        }

        setResourceState((prevState) => ({
            ...prevState,
            [type]: [...prevState[type], resource]
        }));
    };

    const clearResources = (type) => {
        setResourceState((prevState) => ({ ...prevState, [type]: [] }));
    };

    const deleteResource = (type, identifier) => {
        setResourceState((prevState) => ({
            ...prevState,
            [type]: prevState[type].filter((item) => item !== identifier)
        }));
    };

    useEffect(() => {
        setResourceState({
            selectedIps: ips || [],
            selectedHostnames: hostnames || []
        });
    }, [ips, hostnames]);

    return { resourceState, addResource, clearResources, deleteResource };
};
